import React from "react";
import "./SmallButton.scss";
import { Button as KendoButton } from "@progress/kendo-react-buttons";

const SmallButton = (props) => {
  const className = props.className
    ? `${props.className} instream-small-button`
    : "instream-small-button";

  const handleClick = (e) => {
    props.onChange({
      target: null,
      value: e.target.value,
    });
  };

  const generateLabel = (label) => {
    if (label == null || label === "") {
      return;
    } else {
      return label;
    }
  };

  return (
    <KendoButton
      {...props}
      icon={props.icon ? props.icon : ""}
      primary={props.primary === false ? false : true}
      look={props.outline ? "outline" : ""}
      disabled={props.disabled ? props.disabled : false}
      className={className}
      onClick={handleClick}
    >
      {generateLabel(props.label)}
    </KendoButton>
  );
};

export default SmallButton;
